module.exports = __webpack_public_path__ + "static/media/banner_bg_landingpage_mobile.7a2aabb6.png";